/**
 * Macboot Zoom Override v5 (2026-05-06)
 * Aggressive injection with periodic check + console logs.
 */
(function() {
  'use strict';
  console.log('[MacbootZoom] Override v5 loaded');

  function neutralizeOnce() {
    if (typeof customElements === 'undefined') return false;
    var ctor = customElements.get('product-image-zoom');
    if (!ctor) return false;
    if (ctor.prototype.__macbootPatched) return true;
    var proto = ctor.prototype;
    proto.onMouseMoveHandler = function() {};
    proto.onResizeHandler = function() {
      if (this.image) {
        this.image.removeAttribute('style');
        this.image.classList.remove('portrait');
      }
    };
    proto._productZoomMount = function() {
      if (this.image) this.image.removeAttribute('style');
      var self = this;
      setTimeout(function() {
        self.zoom.classList.add('loaded');
        injectCloseButton(self.zoom);
      }, 30);
    };
    proto.__macbootPatched = true;
    console.log('[MacbootZoom] Component patched');
    return true;
  }

  function closeZoom() {
    var zoom = document.getElementById('zoom');
    if (!zoom) return;
    zoom.classList.remove('opened', 'loaded');
    var img = zoom.querySelector('img');
    if (img) {
      img.removeAttribute('style');
      img.src = '';
    }
    document.body.style.overflow = '';
  }

  function injectCloseButton(zoom) {
    if (!zoom) zoom = document.getElementById('zoom');
    if (!zoom) return false;
    if (zoom.querySelector('.macboot-close-btn')) return true;
    
    var btn = document.createElement('button');
    btn.className = 'macboot-close-btn';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Fechar');
    btn.innerHTML = '<span class="macboot-x"></span><span class="macboot-x macboot-x-2"></span>';
    
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      closeZoom();
    });
    
    zoom.appendChild(btn);
    console.log('[MacbootZoom] Close button injected');
    return true;
  }

  function init() {
    // Patch the component
    if (!neutralizeOnce()) {
      var tries = 0;
      var patchInterval = setInterval(function() {
        tries++;
        if (neutralizeOnce() || tries > 30) clearInterval(patchInterval);
      }, 200);
    }

    // Aggressive button injection — check every 500ms
    setInterval(function() {
      var zoom = document.getElementById('zoom');
      if (zoom && !zoom.querySelector('.macboot-close-btn')) {
        injectCloseButton(zoom);
      }
    }, 500);

    // Esc closes
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeZoom();
    });

    // Click on overlay closes
    document.addEventListener('click', function(e) {
      var zoom = document.getElementById('zoom');
      if (!zoom || !zoom.classList.contains('opened')) return;
      if (e.target === zoom) closeZoom();
    });

    // Listen for clicks on zoom hotspots — inject button right after
    document.addEventListener('click', function(e) {
      var hotspot = e.target.closest('product-image-zoom, .product-gallery-item__zoom');
      if (hotspot) {
        // Wait for zoom to open, then inject button
        setTimeout(function() { injectCloseButton(); }, 50);
        setTimeout(function() { injectCloseButton(); }, 200);
        setTimeout(function() { injectCloseButton(); }, 500);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
